<template>
  <div class="d-flex flex-column align-items-start">
    <label for="agree" class="text-left mb-0">{{ content.label }}</label>
    <div class="input-wrap">
      <input v-model="codeInput" @input="onCodeInput" maxlength="25" type="text" name="" id="" :class="errorMsg ? 'error' : ''" :disabled="!canAddCodes()">
      <div v-if="errorMsg" class="error-msg d-flex mt-1">
        <i class="icon icon-error"></i>
        <p>{{ errorMsg }}</p>
      </div>

      <button @click="onCodeSubmit" @keydown.Enter="onCodeSubmit" class="add-another-code d-flex align-items-center" :disabled="!canAddCodes()">
        <img src="/images/alterra/icon_plus.png" class="mr-1" alt="">
        <p v-text="addCodeBtnCopy()"></p>
      </button>

      <div class="added-codes">
        <div v-for="(code, index) in codes" :key="index" class="code">
          <p class="value">{{ code }}</p>
          <button @click="onRemoveCode($event)" @keydown.Enter="onRemoveCode($event)" class="remove-code">
            <img src="/images/icon_close.png" alt="Remove this code">
          </button>
        </div>
      </div>
    </div>

  </div>
  <div class="d-flex justify-content-center mt-3">
    <button @click="onSubmit" @keydown.Enter="onSubmit" class="btn-1" :disabled="!canSubmit()">{{ content.cta_copy }}</button>
    <!-- <input type="submit" id="link-form-submit" class="btn-1" :value="content.cta_copy" /> -->
  </div>
  <p class="text-center mt-2">{{ content.note }}</p>
  <div class="loading-spinner"></div>
</template>

<script setup>
import {defineProps, ref} from 'vue';
import {hideSpinner, q, showSpinner} from '../../utilities';
import axios from 'axios';

const props = defineProps({
  locale: [String],
  relink: [Boolean],
  partnership: [String],
  slug: [String],
  remainingQuota: [Number],
});

const content = APP_alterra_content.account_link_form;
const codeInput = ref('');
const codes = ref([]);
const codesCount = ref(0);
const errorMsg = ref('')
const baseUrl = ref('');

const addCodeBtnCopy = () => codesCount.value ? content.add_another_code : content.add_your_code;
const canAddCodes = () => codesCount.value < +props.remainingQuota;
const canSubmit = () => codesCount.value > 0 && codeInput.value === '';

axios.defaults.headers.common['X-CSRF-TOKEN'] = q('meta[name="csrf-token"]').content;

function onCodeInput() {
  errorMsg.value = '';
}

function onCodeSubmit() {
  if (codeInput.value.trim() === '') {
    errorMsg.value = content.error.not_blank;
  } else if (codes.value.includes(codeInput.value)) {
    errorMsg.value = content.error.duplicate;
  } else if (codesCount.value >= +props.remainingQuota) {
    errorMsg.value = 'You can only add up to ' + props.remainingQuota + ' codes.';
  } else {
    codes.value.push(codeInput.value);
    codeInput.value = '';
    codesCount.value++;
    errorMsg.value = '';
  }
}

function onRemoveCode(e) {
  const selectedCode = e.target.previousElementSibling.textContent;
  codes.value = codes.value.filter(code => code !== selectedCode);
  codesCount.value--;
}

function onSubmit() {

  const formEl = q('form#fna-award-form');

  if (canSubmit()) {
      showSpinner();
      baseUrl.value = '/' + props.slug + '/' + props.locale + '/';
      // [ AJAX ]
      axios.post(formEl.getAttribute('action'), { codes: codes.value})

        .then(function(response) {
          console.log('axios post success');
          window.location.href = response.data.redirectUri;
        })

        .catch(function(error) {
          console.log('axios post error');
          const generalErrorUri = baseUrl.value + 'error';
          const redirectUri = error.response.data.redirectUri || generalErrorUri;

          switch (error.response.status) {
            // not authenticated
            case 401:
              window.location.href = baseUrl.value + 'signed-out';
              break;

            // already linked
            case 409:
              window.location.href = redirectUri;
              break;

            // session expired or invalid csrf token
            case 419:
              window.location.reload();
              break;

            // server-side validation failed (via BenefitChoiceService or FormRequest)
            case 422:
              console.dir(error.response)

              if (error.response.data.errors) {
                errorMsg.value = error.response.data.errors.codes[0];
              } else {
                window.location.href = redirectUri;
              }

              break;

            // member not authorized to make a selection
            case 403:
            // fall through (maybe we should send them to 'not eligible', but the error page would make it easier for them to try again

            // general backend error
            case 500:
            // fall through

            default:
              window.location.href = redirectUri;
          }
        })

        .then(function() {
          hideSpinner();
        });
    }

}
</script>
